import _ from 'underscore';
import moment from 'moment';
import templateStr from 'text!./withdraw.html';
import 'portalConfig';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        transclude: true,
        scope: {
            period: '='
        },
        controller: ['$rootScope', '$scope', 'PolicyService', '$q', 'ModalService', 'ViewModelService', '$state', '$filter', '$stateParams', '$window', function ($rootScope, $scope, PolicyService, $q, ModalService, ViewModelService, $state, $filter, $stateParams, $window) {

            $scope.today = new Date();
            $scope.selectedList = {};
            $scope.selectedData = [];
            $scope.withdrawChooseComplete = false;
            $scope.mode = "full";

            //$scope.ETCountries="";
            var currentDate = PolicyService.getCurrentDate();
            currentDate.then(function (res) {
                $scope.today = new Date(res);
                var actualDate = new Date(res);
                actualDate.setDate(actualDate.getDate() + 1);
                $scope.finalDate = {
                    year: actualDate.getFullYear(),
                    month: actualDate.getMonth(),
                    day: actualDate.getDate()
                };
                $scope.effectiveDate = $scope.finalDate;
            });

            $scope.effectiveDate = $scope.period.effective;

            /*var actualDate = new Date();
             //actualDate.setMonth($scope.submissionVM.baseData.periodStartDate.value.month);
                actualDate.setDate(actualDate.getDate()+1);
               // actualDate.setYear($scope.submissionVM.baseData.periodStartDate.value.year);
                
                $scope.finalDate= {
                year: actualDate.getFullYear(),
                month: actualDate.getMonth(),
                day: actualDate.getDate()
            	};
                $scope.effectiveDate=$scope.finalDate;*/

            PolicyService.getPolicyChangeOptions().then(function (res) {
                $scope.requestDataList = res;
                $scope.dataLoaded = true;
            });
            $scope.hideForm = function () {
                $scope.hideWithdrawSection = true;
                $scope.$emit("hideWithdrawSection");
            };

            $scope.policyNumber = $stateParams.policyNumber;
            // Added to refresh error message for options validation after form submit_MSF
            $scope.$watchCollection('selectedList', function (newVal, oldVal) {

                if (newVal == oldVal) return;
                $scope.selectedDataList = [];
                angular.forEach($scope.selectedList, function (selected, res) {
                    if (selected) {
                        $scope.selectedDataList.push(res);
                    }
                });
                if ($scope.selectedDataList.length == 0 || $scope.selectedDataList.length == -1) {
                    $scope.validationMsg = true;
                } else {
                    $scope.validationMsg = false;
                }
                if ($scope.selectedDataList.length > 1) {
                    if ($scope.selectedDataList.indexOf($filter('translate')('directives.policy-change.Estimated Wages')) != -1 || $scope.selectedDataList.indexOf($filter('translate')('policy.common.directives.mailingAddress')) != -1) {
                        $scope.wagesOnlyOption = true;
                    } else {
                        $scope.wagesOnlyOption = false;
                    }
                    //swos only
                    if ($scope.selectedDataList.indexOf($filter('translate')('gateway.controllers.policy.policychange.Specific Waiver of Subrogation')) != -1) {
                        $scope.swosOnlyOption = true;
                    } else {
                        $scope.swosOnlyOption = false;
                    }
                    //Setting Add Remove location only error variable

                    if ($scope.selectedDataList.indexOf($filter('translate')('policy.common.directives.policy-location.AddEditRemoveLocation')) != -1) {
                        $scope.addRemoveLocationOnlyOption = true;
                    } else {
                        $scope.addRemoveLocationOnlyOption = false;
                    }
                } else {
                    $scope.wagesOnlyOption = false;
                    $scope.swosOnlyOption = false;
                    $scope.addRemoveLocationOnlyOption = false;
                }
            });
            var currentDate = PolicyService.getCurrentDate();
            currentDate.then(function (res) {
                var actualDate = new Date(res);
                actualDate.setDate(actualDate.getDate() + 1);
                $scope.finalDate = {
                    year: actualDate.getFullYear(),
                    month: actualDate.getMonth(),
                    day: actualDate.getDate()
                };
                $scope.effectiveDate = $scope.finalDate;
                $scope.policyChange = {
                    'policyNumber': $scope.policyNumber,
                    'effectiveDate': $scope.effectiveDate,
                    'description': 'Portal Side Policy Change'
                };
            });

            //method to have only the date from date object
            $scope.trimDate = function (fullDate) {
                return moment(fullDate).format('YYYY-MM-DD');
            };

            $scope.triggerPolicyChangeForEW = function () {
                //Assigning period public Id
                $scope.policyChange.effectiveDate = $scope.trimDate($scope.period.effective);
                $scope.disableSubmit = true;
                $scope.effectiveDateError = false;
                $scope.policyChange.description = $scope.selectedDataList.join(', ').toString().replace(/"/g, "");
                var newPolicyChangeRequest = PolicyService.createNewPolicyChangeTransaction($scope.policyChange);
                $scope.newPolicyChangeRequest = newPolicyChangeRequest;
                if ($scope.selectedData == "Waiver of Subrogation") {
                    ModalService.showError(" ", 'Please select a waiver to continue.');
                    return;
                }
                newPolicyChangeRequest.then(function (job) {
                    $scope.jobNumber = job.JobNumber;
                    // Prevent users from entering the transaction screen by clicking back button -DEF0618
                    $rootScope.allowPolicyChangeEvent = true;
                    if (job.jobNumber != undefined) {
                        $state.go('newPolicyChange', {
                            policyNumber: $stateParams.policyNumber,
                            data: $scope.selectedDataList,
                            jobNumber: job.jobNumber,
                            accountName: job.msfAccountName,
                            effDate: $scope.policyChange.effectiveDate
                        });
                    }
                }, function (error) {
                    ModalService.showError(" ", 'Cannot complete policy change request. Please contact Montana State Fund for assistance.');
                });
            };
            //method to format date
            $scope.formatDate = function (policyChangeDate) {
                return $filter('date')(policyChangeDate, 'MM/dd/yyyy');
            };

            $scope.triggerPolicyChange = function () {
                $scope.period.effective = $scope.trimDate($scope.period.effective);
                var actualDate = new Date();
                actualDate.setMonth($scope.effectiveDate.month);
                actualDate.setDate($scope.effectiveDate.day);
                actualDate.setYear($scope.effectiveDate.year);
                $scope.disableSubmit = true;
                $scope.effectiveDateError = false;
                $scope.outOfTerm = false;
                var isEffectiveDateValid = false;
                $scope.policyChange.effectiveDate = $scope.trimDate(actualDate);
                //policy change effective date if swos has been selected
                if ($scope.selectedData.length == 1 && $scope.selectedData.indexOf($filter('translate')('gateway.controllers.policy.policychange.Specific Waiver of Subrogation')) != -1) {
                    $scope.policyChange.effectiveDate = $scope.trimDate($scope.period.effective);
                }

                $scope.policyChange.description = $scope.selectedDataList.join(', ').toString().replace(/"/g, "");
                var effDate = PolicyService.getEffectiveDateForPolicyChange($scope.policyNumber, $scope.period.effective);
                effDate.then(function (date) {
                    if (date != undefined) {
                        //setting up date formats
                        date.effectiveDate = $scope.trimDate(date.effectiveDate);
                        date.expirationDate = $scope.trimDate(date.expirationDate);
                        if (moment($scope.policyChange.effectiveDate).isSameOrAfter(date.effectiveDate) && moment(date.expirationDate).isAfter($scope.policyChange.effectiveDate)) {
                            isEffectiveDateValid = true;
                        }
                        if (!(moment($scope.policyChange.effectiveDate).isSameOrAfter($scope.period.effective) && moment(date.expirationDate).isAfter($scope.policyChange.effectiveDate))) {
                            $scope.outOfTerm = true;
                        }
                    } else {
                        isEffectiveDateValid = true;
                    }
                    $scope.estWageSelected = true;
                    if (isEffectiveDateValid) {
                        var newPolicyChangeRequest = PolicyService.createNewPolicyChangeTransaction($scope.policyChange);
                        $scope.newPolicyChangeRequest = newPolicyChangeRequest;
                        newPolicyChangeRequest.then(function (job) {

                            // Prevent users from entering the transaction screen by clicking back button -DEF0618
                            $rootScope.allowPolicyChangeEvent = true;
                            $scope.jobNumber = job.JobNumber;
                            if (job.jobNumber != undefined) {
                                $state.go('newPolicyChange', {
                                    policyNumber: $stateParams.policyNumber,
                                    data: $scope.selectedDataList,
                                    jobNumber: job.jobNumber,
                                    accountName: job.msfAccountName,
                                    effDate: $scope.policyChange.effectiveDate
                                });
                            }
                        }, function (error) {
                            $scope.disableSubmit = false;
                            ModalService.showError(" ", 'Cannot complete policy change request. Please contact Montana State Fund for assistance.');
                        });
                    } else {
                        $scope.disableSubmit = false;
                        $scope.effectiveDateError = true;
                    }
                }, function (error) {
                    //stopping user from proceeding when period is null for the current date
                    $scope.disableSubmit = false;
                    $scope.effectiveDateError = true;
                });
            };

            $scope.selectedWaiver = function () {

                $scope.selectedData[0] = $scope.waiverSubType;
                $scope.selectedDataList[0] = $scope.waiverSubType;
                $scope.disableSubmit = false;

                if ($scope.waiverSubType == "Blanket Waiver of Subrogation" && $scope.blanketWosExist) {
                    $scope.disableSubmit = true;
                    ModalService.showError(" ", 'Blanket Waiver of Subrogation Already Exists. Only one Blanket Waiver of Subrogation is allowed for a policy term');
                }
            };

            /**
             * Function : Check for waiver of subrogation is already present if it exists update the scope object.
             * @params{Object} 	- $scope.jobNumber
             * @returns{Object} - $scope object is populated with values. CompanyName, Address, QuoteAdditionalInfo, PostalCode and PublicId
             * @private
             **/
            $scope.wosCheck = function () {
                // Check whether WOS is already added to the jobNumber
                var WOSExist = PolicyService.getExistingWOS($scope.policyNumber);
                WOSExist.then(function (res) {
                    if (res) {
                        $scope.isWosExist = true;
                        $scope.wosArray = res;
                        angular.forEach($scope.wosArray, function (wos) {
                            if (wos.wosType == "Blanket") {
                                $scope.blanketWosExist = true;
                            }
                        });
                    } else {
                        $scope.wosArray = {};
                        $scope.isWosExist = false;
                    }
                }, function () {
                    $scope.wosArray = {};
                    $scope.isWosExist = false;
                });
            };
            //Continue to the next step_MSF
            $scope.startWithdraw = function (form) {

                $scope.withdrawChooseComplete = false;$scope.selectedData = [];
                $scope.swosMidPage = false;
                angular.forEach($scope.selectedList, function (selected, res) {
                    if (selected) {
                        PolicyService.callEUTS('Policy Change Selection', res, $scope.policyNumber);
                        $scope.selectedData.push(res);
                    }
                });
                if ($scope.selectedData.length == 0 || $scope.selectedData.length == -1) {
                    $scope.validationMsg = true;
                    return;
                }

                if ($scope.selectedData.length != undefined && $scope.selectedData.length > 1) {
                    if ($scope.selectedData.indexOf($filter('translate')('directives.policy-change.Estimated Wages')) != -1) {
                        $scope.wagesOnlyOption = true;
                        return;
                    }
                    if ($scope.selectedData.indexOf($filter('translate')('gateway.controllers.policy.policychange.Specific Waiver of Subrogation')) != -1) {
                        $scope.swosOnlyOption = true;
                        return;
                    }
                    if ($scope.selectedData.indexOf($filter('translate')('policy.common.directives.policy-location.AddEditRemoveLocation')) != -1) {
                        $scope.addRemoveLocationOnlyOption = true;
                        return;
                    }
                }
                if ($scope.selectedData.length == 1 && ($scope.selectedData.indexOf($filter('translate')('policy.common.directives.policy-location.AddEditRemoveLocation')) != -1 || $scope.selectedData.indexOf($filter('translate')('policy.common.directives.mailingAddress')) != -1 || $scope.selectedData.indexOf($filter('translate')('directives.policy-change.Estimated Wages')) != -1)) {
                    $scope.triggerPolicyChangeForEW();
                    //$scope.disableSubmit=false;
                    return;
                } else if ($scope.selectedData.indexOf($filter('translate')('gateway.controllers.policy.policychange.Specific Waiver of Subrogation')) != -1) {
                    $scope.swosMidPage = true;
                    $scope.wosCheck();
                    $scope.withdrawChooseComplete = false;
                } else {
                    //$scope.$emit("withdrawChooseComplete");
                    //$scope.submitDisabled="false";
                    $scope.withdrawChooseComplete = true;
                    $scope.swosMidPage = false;
                }
                //setting up waiver
                if ($scope.selectedData.length == 1 && $scope.selectedData.indexOf($filter('translate')('gateway.controllers.policy.policychange.Specific Waiver of Subrogation')) != -1) {
                    $scope.effectiveDate = $scope.trimDate($scope.period.effective);
                    $scope.finalDate = $scope.trimDate($scope.period.effective);
                }
            };
        }]
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/WithdrawDirective_MSF/Withdraw.js
// module id = 1770
// module chunks = 0